define.alias("shared/components/shared/social/tiktok-connection-status", "calendar/components/shared/social/tiktok-connection-status");